import React from 'react';
import { MobilePageTransition } from './MobilePageTransition';

const MAX_NOTE_LENGTH = 500;

const NoteSheet = ({ 
  show, 
  onClose, 
  noteText, 
  setNoteText, 
  onSave, 
  isDarkMode,
  verseKey 
}) => {
  const handleTextChange = (e) => {
    const text = e.target.value;
    // Limit text to maximum length
    if (text.length <= MAX_NOTE_LENGTH) {
      setNoteText(text);
    }
  };

  const charCount = noteText?.length || 0;
  const isApproachingLimit = charCount > MAX_NOTE_LENGTH * 0.8;
  const isAtLimit = charCount >= MAX_NOTE_LENGTH;

  return (
    <MobilePageTransition
      show={show}
      onClose={onClose}
      title={`Note for Verse ${verseKey}`}
      isDarkMode={isDarkMode}
      rightButton={{
        text: 'Save',
        onClick: onSave
      }}
    >
      <div className="p-4">
        <textarea
          value={noteText}
          onChange={handleTextChange}
          placeholder="Add your note here..."
          className={`w-full h-48 p-4 rounded-xl resize-none ${
            isDarkMode 
              ? 'bg-[#111111] text-white border-gray-800 focus:border-gray-700' 
              : 'bg-white text-gray-900 border-gray-200 focus:border-gray-300'
          } border focus:ring-0 focus:outline-none transition-colors duration-200`}
          autoFocus
          maxLength={MAX_NOTE_LENGTH}
        />
        <div className={`flex justify-end mt-2 text-xs ${
          isAtLimit
            ? 'text-red-500'
            : isApproachingLimit
              ? 'text-yellow-500'
              : isDarkMode ? 'text-gray-400' : 'text-gray-500'
        }`}>
          {charCount}/{MAX_NOTE_LENGTH} characters
        </div>
      </div>
    </MobilePageTransition>
  );
};

export default NoteSheet; 